import { AcceptedWindow, DateRules, DateSpan } from './rules';
import { weekdayOf } from './weekday';

export function admits(rules: DateRules, date: string): boolean {
  if (rules.exclude.some((exclusion) => covers(exclusion, date))) return false;

  return rules.accept.some((window) => windowAdmits(window, date));
}

export function covers(span: DateSpan, date: string): boolean {
  return span.from <= date && date <= span.to;
}

export function windowAdmits(window: AcceptedWindow, date: string): boolean {
  if (!covers(window, date)) return false;

  return window.weekdays.length === 0 || window.weekdays.includes(weekdayOf(date));
}
